<template lang="pug">
.popup-edit(:data-show='isShowPopup')
  button-base.popup-edit__open-button(@click='showPopup')
  .popup-edit__popup
    .popup-edit__popup__overlay(@click='hidePopup')
    .popup-edit__popup__body
      button-icon-text.popup-edit__popup__body__button(
        v-if='deleteEvent',
        @click='doDelete',
        type='remove',
        iconColor='red'
      )
        slot(name='removeText')
      button-icon-text.popup-edit__popup__body__button(@click='doEdit', type='edit')
        slot(name='editText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ButtonIconText from '@/components/molecules/manager/ButtonIconText.vue'
import { PopupEditSetting } from '@/const/DisplaySettings'

/**
 * 編集ポップアップ
 */
@Component({
  components: {
    ButtonBase,
    ButtonIconText,
  },
})
export default class PopupEdit extends Vue {
  // 表示初期値
  private isShowPopup = false

  // 削除ボタン押下時イベント
  @Prop()
  deleteEvent?: Function

  // 編集ボタン押下時イベント
  @Prop()
  editEvent!: Function

  // 編集・削除対象のID
  @Prop()
  editId!: number

  // 入力ポップアップを表示
  private showPopup() {
    this.isShowPopup = true
  }

  // 入力ポップアップを閉じる
  private hidePopup() {
    this.isShowPopup = false
  }

  // 削除イベント実行
  private async doDelete() {
    if (this.deleteEvent && confirm(PopupEditSetting.DELETE_CONFIRM_MESSAGE)) {
      await this.deleteEvent(this.editId)
      this.hidePopup()
    }
  }

  // 編集イベント実行
  private async doEdit() {
    await this.editEvent(this.editId)
    this.hidePopup()
  }
}
</script>

<style lang="stylus" scoped>
.popup-edit
  display flex

  &__open-button
    display flex
    width 24px
    height 24px
    justify-content center
    align-items center
    border-radius 60px
    border 1px solid var(--color-manager-edit-popup-open-button__background)
    background-image url('~@/assets/img/common/icon/popup-edit/default.svg')
    background-position center
    background-repeat no-repeat

    &:hover
      background-color var(--color-manager-edit-popup-open-button__background)
      background-image url('~@/assets/img/common/icon/popup-edit/active.svg')

  &[data-show='true'] &__open-button
    background-color var(--color-manager-edit-popup-open-button__background)
    background-image url('~@/assets/img/common/icon/popup-edit/active.svg')

  &__popup
    display none
    position relative

    &__overlay
      position fixed
      left 0
      top 0
      z-index 5
      width 100%
      height 100%

    &__body
      position absolute
      top 40px
      right 0
      z-index 10
      display flex
      width 152px
      padding 10px
      flex-direction column
      align-items flex-start
      gap 3px
      border-radius 15px
      background var(--color-manager-edit-popup__background)
      box-shadow 0px 30px 60px 0px var(--color-manager-edit-popup__shadow)

  &[data-show='true'] &__popup
    display block
</style>
